// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceReplenishmentMetricsResponseDto } from './IInvoiceReplenishmentMetricsResponseDto';
import {
    IInvoiceReplenishmentMetricsResponseDtoFromJSON,
    IInvoiceReplenishmentMetricsResponseDtoFromJSONTyped,
    IInvoiceReplenishmentMetricsResponseDtoToJSON,
    IInvoiceReplenishmentMetricsResponseDtoToJSONTyped,
} from './IInvoiceReplenishmentMetricsResponseDto';

/**
 * 
 * @export
 * @interface IInvoicePlanLevelReplenishmentMetricsResponseDto
 */
export interface IInvoicePlanLevelReplenishmentMetricsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IInvoicePlanLevelReplenishmentMetricsResponseDto
     */
    plan_id?: number;
    /**
     * 
     * @type {IInvoiceReplenishmentMetricsResponseDto}
     * @memberof IInvoicePlanLevelReplenishmentMetricsResponseDto
     */
    statistics?: IInvoiceReplenishmentMetricsResponseDto;
}

/**
 * Check if a given object implements the IInvoicePlanLevelReplenishmentMetricsResponseDto interface.
 */
export function instanceOfIInvoicePlanLevelReplenishmentMetricsResponseDto(value: object): value is IInvoicePlanLevelReplenishmentMetricsResponseDto {
    return true;
}

export function IInvoicePlanLevelReplenishmentMetricsResponseDtoFromJSON(json: any): IInvoicePlanLevelReplenishmentMetricsResponseDto {
    return IInvoicePlanLevelReplenishmentMetricsResponseDtoFromJSONTyped(json, false);
}

export function IInvoicePlanLevelReplenishmentMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoicePlanLevelReplenishmentMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'statistics': json['statistics'] == null ? undefined : IInvoiceReplenishmentMetricsResponseDtoFromJSON(json['statistics']),
    };
}

export function IInvoicePlanLevelReplenishmentMetricsResponseDtoToJSON(json: any): IInvoicePlanLevelReplenishmentMetricsResponseDto {
    return IInvoicePlanLevelReplenishmentMetricsResponseDtoToJSONTyped(json, false);
}

export function IInvoicePlanLevelReplenishmentMetricsResponseDtoToJSONTyped(value?: IInvoicePlanLevelReplenishmentMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'statistics': IInvoiceReplenishmentMetricsResponseDtoToJSON(value['statistics']),
    };
}

